import { ts } from '_core';

import { validate } from './helpers';
import { DraftParams, INTERACTION_PARAMS } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.METRIC_BASKET_ALLOCATION,
    form: true,
    helpLabel: '5ctqiujf',
    title: 'Basket Allocation',
    neededFiles: ['backtest_details'],
    interactionParams: Object.values(INTERACTION_PARAMS),
    defaultParams: { type: 'show_all' } as DraftParams,
    tags: [ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.BASKET_ADHOC],

    validate,
    getAdhocData: (pathFile, params) => {
      return {
        name: `Basket Allocation for ${params.details_start_date}`,
        file_name: pathFile,
        description: `This file contains the asset allocation of a basket as of ${params.details_start_date}.`,
        columns: [
          { key: 'asset', name: 'name', description: 'Asset name', type: 'string' },
          {
            key: 'main_initial',
            name: 'initial',
            description: 'Allocation before optimization.',
            type: 'float',
          },
          {
            key: 'main_optimal',
            name: 'optimal',
            description: 'Optimal allocation after optimization.',
            type: 'float',
          },
          {
            key: 'main_after_costs',
            name: 'allocation',
            description: 'Allocation after returns and after costs.',
            type: 'float',
          },
          { key: 'rbics_l1_name', name: 'sector', description: 'Asset sector.', type: 'string' },
          {
            key: 'rbics_l3_name',
            name: 'industry',
            description: 'Asset industry.',
            type: 'string',
          },
        ],
      };
    },
  },
] satisfies ts.types.analysis.WidgetConfig[];
